<ng-container *transloco="let t; read: 'configuration-blacklist-component'"
  ><app-configuration-item-editor
    [configuration]="configuration()"
    [configurationLayers]="configurationLayers()"
    itemTypeTitle="Blacklist item"
    searchPlaceholder="{{ t('item-type') }}"
    [loadItemsApi]="loadItems"
    [createItemApi]="createItem"
    [saveItemApi]="saveItem"
    [deleteItemApi]="deleteItem"
    [deleteAllItemsApi]="deleteAllItems"
    [queryEditable]="false"
    [itemsEditable]="editable"
    [selectedItemName]="selectedItemName"
    [selectedItemId]="selectedItemId"
    fragment="blacklist"
    [addPopoverTemplate]="addButtonTemplate"
    (itemsLoaded)="onItemsLoaded($event)"
    (itemsDeleted)="onItemsDeleted($event)"
    (allItemsDeleted)="onAllItemsDeleted($event)"
    (itemAdded)="onItemAdded($event)"
    (itemUpdated)="onItemUpdated($event)"
  ></app-configuration-item-editor>

  <ng-template #addButtonTemplate let-data>
    <p class="configuration-blacklist__add-popover">
      {{ t('no-entry', { data }) }}
    </p>
  </ng-template>
</ng-container>
